<template>
  <form class="form form-base">
    <div class="form-base__title mb-4">{{ formTitle }}</div>

    <v-row v-if="selectableType">
      <v-col cols="12">
        <v-select
          :items="DOCUMENT_TYPE"
          label="Тип документа"
          v-model="selectedType"
          item-text="text"
          item-value="value"
          :disabled="isEditMode"
          outlined
        ></v-select>
      </v-col>
    </v-row>

    <!--- Подтверждение полномочий--->
    <template
      v-if="
        selectableType &&
        selectedType === DocumentType.CONFIRMATION_OF_AUTHORITY
      "
    >
      <ConfirmationAuthorityForm
        :document="documentEdit"
        ref="confirmationAuthority"
      />
    </template>

    <!--- Подтверждение статуса--->
    <template
      v-if="
        selectableType && selectedType === DocumentType.CONFIRMATION_OF_STATUS
      "
    >
      <ConfirmationStatusForm
        :document="documentEdit"
        ref="confirmationStatus"
      />
    </template>

    <!--- МЧД --->
    <template v-if="selectableType && selectedType === DocumentType.MRP">
      <MrpForm :document="documentEdit" ref="mrp" />
    </template>

    <!--- Другой тип файлов -->
    <template
      v-if="
        (selectableType && selectedType === DocumentType.FILE) ||
        !selectableType
      "
    >
      <AddingRegularFileForm
        ref="addingRegularFileForm"
        :document="documentEdit"
      />
    </template>
    <div>
      <v-row justify="end">
        <v-col cols="auto">
          <v-btn @click="closeModal" depressed class="button-base-white">
            Отмена
          </v-btn>
        </v-col>

        <v-col cols="auto">
          <v-btn
            @click="upload"
            depressed
            color="primary"
            class="button-base"
            :loading="loading"
            :disabled="!selectedType"
          >
            {{ buttonText }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </form>
</template>

<script>
import { getValidationErrorText } from '@/utils/validate';
import { DocumentType } from '@/types/services';
import ConfirmationStatusForm from '@/components/base/ConfirmationStatusForm';
import AddingRegularFileForm from '@/components/base/AddingRegularFileForm';
import ConfirmationAuthorityForm from '@/components/base/ConfirmationAuthorityForm';
import { errorHandler, isNotEmptyObjectCheck } from '@/utils/common';
import { saveDocument } from '@/api/profile';
import MrpForm from '@/components/profile/personal-details/documents/MrpForm';

const DOCUMENT_TYPE = [
  {
    value: DocumentType.CONFIRMATION_OF_AUTHORITY,
    text: 'Документ, подтверждающий полномочия представителя',
  },
  {
    value: DocumentType.CONFIRMATION_OF_STATUS,
    text: 'Документ, подтверждающий должность или статус представителя',
  },
  {
    value: DocumentType.MRP,
    text:
      'Машиночитаемая доверенность, подтверждающая полномочия представителя',
  },
  { value: DocumentType.FILE, text: 'Другой тип документа' },
];

export default {
  name: 'UploadingForm',
  components: {
    ConfirmationAuthorityForm,
    AddingRegularFileForm,
    ConfirmationStatusForm,
    MrpForm,
  },
  props: {
    selectableType: {
      type: Boolean,
      default: false,
    },
    single: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: 1e6,
      required: false,
    },
    documents: {
      type: Array,
    },
    documentEdit: {
      type: Object,
    },
  },
  data: () => ({
    DOCUMENT_TYPE,
    DocumentType,
    getValidationErrorText,

    loading: false,
    selectedType: '',
  }),

  async created() {
    await this.reset();
    if (isNotEmptyObjectCheck(this.documentEdit)) {
      this.selectedType = this.documentEdit.type;
    }
  },
  computed: {
    formTitle() {
      return this.isEditMode
        ? 'Редактирование реквизитов документа'
        : 'Добавление документа';
    },
    isEditMode() {
      return isNotEmptyObjectCheck(this.documentEdit);
    },
    buttonText() {
      return this.isEditMode ? 'Сохранить' : 'Прикрепить документ к профилю';
    },
  },
  methods: {
    async closeModal() {
      this.$emit('close', true);
    },
    async reset() {
      this.selectedType = '';
      if (this.$refs.addingRegularFileForm) {
        await this.$refs.addingRegularFileForm.reset();
      }
      if (this.$refs.confirmationStatus) {
        await this.$refs.confirmationStatus.reset();
      }
      if (this.$refs.confirmationAuthority) {
        await this.$refs.confirmationAuthority.reset();
      }
      if (this.$refs.mrp) {
        await this.$refs.mrp.reset();
      }
    },

    async getChildFormData() {
      if (this.selectedType === DocumentType.CONFIRMATION_OF_STATUS) {
        return await this.$refs.confirmationStatus.upload();
      }

      if (this.selectedType === DocumentType.CONFIRMATION_OF_AUTHORITY) {
        return await this.$refs.confirmationAuthority.upload();
      }

      if (this.selectedType === DocumentType.FILE) {
        return await this.$refs.addingRegularFileForm.upload();
      }

      if (this.selectedType === DocumentType.MRP) {
        return await this.$refs.mrp.upload();
      }
    },

    async upload() {
      this.loading = true;
      try {
        const data = await this.getChildFormData();
        if (data) {
          await saveDocument(data);
          this.$emit('close', true);
          this.$emit('change', true);
          await this.reset();
        }

        this.loading = false;
      } catch (error) {
        errorHandler(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss"></style>
